var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.999 2.25a2 2 0 0 1 1.999 2v7.497a2 2 0 0 1-1.999 2H3.003a2 2 0 0 1-2-2V4.25a2 2 0 0 1 2-2h9.996zM2.503 11.747a.5.5 0 0 0 .5.5h9.996a.5.5 0 0 0 .499-.5V6.692H2.503v5.055zm3.044-6.555h1.7V3.75h-1.7v1.442zm3.2 0h4.751V4.25a.5.5 0 0 0-.499-.5H8.747v1.442zM3.003 3.75a.5.5 0 0 0-.5.5v.942h1.544V3.75H3.003z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgApp);
export default ForwardRef;